@if (currentRole == UserRole.Admin) {
  <div class="actions">
    <div class="actions-block favorites p-spacing-xl">
      <h6 class="mb-spacing-xs text-base capitalize text-light-color font-medium line-height-2">Favorite Shortcuts</h6>
      <div class="grid grid-nogutter gap-spacing-xs">
        @for (action of favoriteActions(); track $index) {
          @if (action.isVisible) {
            <button
              [disabled]="action.isDisabled"
              (click)="rideActionsMap()[action.actionKey]['command']()"
              class="fav-action-btn col-6 relative border-round-md justify-content-end p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
              <i [class]="action.icon"></i>
              <span class="text-sm font-medium white-space-nowrap text-overflow-ellipsis max-w-full overflow-hidden">
                {{ action.label }}
              </span>
              <i
                class="icon-star-solid absolute text-sm feedback-warning-fg-color"
                style="top: 8px; right: 8px"></i>
            </button>
          }
        }
      </div>
    </div>

    <div
      class="actions-block menu-container p-spacing-xl"
      #actions_1>
      <div class="flex gap-spacing-xs">
        <div class="btns-container flex gap-spacing-xs">
          <button
            (click)="rideActionsMap()['rideActivity']['command']()"
            [disabled]="!rideActionsMap()['rideActivity']['isVisibleFunction']() || rideActionsMap()['rideActivity']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-steering-wheel-solid"></i>
            <span class="text-sm font-medium">Ride Activity</span>
          </button>
          <button
            (click)="rideActionsMap()['changeRideTime']['command']()"
            [disabled]="!rideActionsMap()['changeRideTime']['isVisibleFunction']() || rideActionsMap()['changeRideTime']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-clock-user-solid"></i>
            <span class="text-sm font-medium">Ride Time</span>
          </button>
        </div>

        <button
          #btn_1
          (click)="showActionsMenu($event, actionsMenu_1, btn_1)"
          class="fav-action-btn more-btn w-3 border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
          <i class="icon-dots-nine"></i>
          <span class="text text-sm font-medium">More</span>
        </button>
        <p-menu
          [appendTo]="'body'"
          [autoZIndex]="true"
          styleClass="actions-menu"
          #actionsMenu_1
          [model]="visibleActionsMenuItems_1()"
          [popup]="true"
          (onHide)="RemoveBtnActiveClass(btn_1)" />
      </div>
    </div>

    <div
      class="actions-block menu-container p-spacing-xl"
      #actions_2>
      <div class="flex gap-spacing-xs">
        <div class="btns-container flex gap-spacing-xs">
          <button
            (click)="rideActionsMap()['assignSubDriver']['command']()"
            [disabled]="!rideActionsMap()['assignSubDriver']['isVisibleFunction']() || rideActionsMap()['assignSubDriver']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-user-circle-plus-solid"></i>
            <span class="text-sm font-medium">Assign Sub-driver</span>
          </button>
          <button
            (click)="rideActionsMap()['rideActivity']['command']()"
            [disabled]="!rideActionsMap()['rideActivity']['isVisibleFunction']() || rideActionsMap()['rideActivity']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-pulse-solid"></i>
            <span class="text-sm font-medium">Activity Log</span>
          </button>
        </div>

        <button
          #btn_2
          (click)="showActionsMenu($event, actionsMenu_2, btn_2)"
          class="fav-action-btn more-btn w-3 border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
          <i class="icon-dots-nine"></i>
          <span class="text text-sm font-medium">More</span>
        </button>
        <p-menu
          [appendTo]="'body'"
          [autoZIndex]="true"
          styleClass="actions-menu"
          #actionsMenu_2
          [model]="visibleActionsMenuItems_2()"
          [popup]="true"
          (onHide)="RemoveBtnActiveClass(btn_2)" />
      </div>
    </div>

    <div
      class="actions-block menu-container p-spacing-xl"
      #actions_3>
      <div class="flex gap-spacing-xs">
        <div class="btns-container flex gap-spacing-xs">
          <button
            (click)="rideActionsMap()['addIncidentReport']['command']()"
            [disabled]="!rideActionsMap()['addIncidentReport']['isVisibleFunction']() || rideActionsMap()['addIncidentReport']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-warning-solid"></i>
            <span class="text-sm font-medium">Incident Report</span>
          </button>
          <button
            (click)="rideActionsMap()['waypointsMap']['command']()"
            [disabled]="!rideActionsMap()['waypointsMap']['isVisibleFunction']() || rideActionsMap()['waypointsMap']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-line-segments-solid"></i>
            <span class="text-sm font-medium">Waypoints Map</span>
          </button>
        </div>

        <button
          #btn_3
          (click)="showActionsMenu($event, actionsMenu_3, btn_3)"
          class="fav-action-btn more-btn w-3 border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
          <i class="icon-dots-nine"></i>
          <span class="text text-sm font-medium">More</span>
        </button>
        <p-menu
          [appendTo]="'body'"
          [autoZIndex]="true"
          styleClass="actions-menu"
          #actionsMenu_3
          [model]="visibleActionsMenuItems_3()"
          [popup]="true"
          (onHide)="RemoveBtnActiveClass(btn_3)" />
      </div>
    </div>

    <p-dialog
      [showHeader]="false"
      [modal]="true"
      [(visible)]="showActionsMenuDialog"
      [dismissableMask]="true"
      [style]="{ width: '260px' }">
      <div class="flex flex-column bg-white">
        <ul class="list-none pl-0 mb-0 my-spacing-3xs">
          @for (item of currentActiveMenu; track $index) {
            @if (item.separator) {
              <hr class="my-0 border-neutral-base-primary-border" />
            } @else {
              <li>
                <button
                  [disabled]="item.disabled"
                  class="w-full bg-transparent border-none action-menu-item flex justify-content-between gap-spacing-md p-spacing-md cursor-pointer"
                  (click)="test($event, item)">
                  <span [class]="'label-large-regular form-label-color ' + item.styleClass">
                    {{ item.label }}
                  </span>
                  <i
                    [class]="item.icon + ' ' + item.iconClass"
                    style="font-size: 1.25rem"></i>
                </button>
              </li>
            }
          }
        </ul>
      </div>
    </p-dialog>
  </div>
} @else if (currentRole == UserRole.Client) {
  <div class="actions">
    <div
      class="actions-block menu-container p-spacing-xl"
      #actions_1>
      <div class="flex gap-spacing-xs">
        <div class="btns-container flex flex-column gap-spacing-xs">
          <button
            (click)="rideActionsMap()['driverInfo']['command']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-user-solid"></i>
            <span class="text-sm font-medium">Driver Information</span>
          </button>
          <button
            (click)="rideActionsMap()['rideActivity']['command']()"
            [disabled]="!rideActionsMap()['rideActivity']['isVisibleFunction']() || rideActionsMap()['rideActivity']['isDisabledFunction']()"
            class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
            <i class="icon-steering-wheel-solid"></i>
            <span class="text-sm font-medium">Ride Activity</span>
          </button>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="actions">
    <div
      class="actions-block menu-container p-spacing-xl"
      #actions_1>
      <div class="flex gap-spacing-xs">
        <div class="btns-container flex flex-column gap-spacing-xs">
          @for (action of allActionsMenuItems(); track $index) {
            @if (!action["separator"] && action["actionKey"] != "waypointsMap") {
              <button
                (click)="rideActionsMap()[action['actionKey']]['command']()"
                class="fav-action-btn w-full border-round-md p-spacing-xs flex flex-column align-items-center gap-spacing-xs background-muted-secondary-bg border-1 border-transparent text-link-color">
                <i [class]="action['actionIcon']"></i>
                <span class="text-sm font-medium">{{ action["label"] }}</span>
              </button>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
